import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExecuteToolbarAction } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';

@Component({
   selector: 'samweb-toolbar',
   templateUrl: './toolbar.component.html',
   styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
   public actionIds$: Observable<string[]>;

   @Input()
   public brickInstanceId: string;

   @Input()
   public toolbarId: string;

   @Input()
   public showVertical: boolean;

   @Input()
   public smallView = false;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.actionIds$ = this.store.select(ToolbarSettingsState.getToolbarActionIdsFn).pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId)));
   }

   executeAction(actionId: string) {
      this.store.dispatch(new ExecuteToolbarAction(this.brickInstanceId, this.toolbarId, actionId, this.store));
   }
}
